import Vue from 'vue'
import Vuex from 'vuex'
import modules from './global'

Vue.use(Vuex)

const Store = new Vuex.Store({
  modules
})

export default Store
